// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog {
  max-width: 80%;
  width: -moz-fit-content;
  width: fit-content;
}
.modal-dialog > .modal-content {
  background-color: var(--modal) !important;
}
.modal-dialog:has(.archivo-modal) {
  width: 90%;
  max-width: initial;
  height: calc(100% - 3.5rem);
}
.modal-dialog:has(.archivo-modal) .modal-content, .modal-dialog:has(.archivo-modal) .modal-body {
  height: 100%;
}
.modal-dialog:has(.archivo-modal) .archivo-modal:has(img) {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

@media (max-width: 575.98px) {
  .modal-dialog {
    max-width: 100% !important;
    width: calc(100% - 1rem) !important;
    height: calc(100vh - 1rem) !important;
  }
  .modal-dialog .modal-content {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modal/modal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,uBAAA;EAAA,kBAAA;AACJ;AAAI;EACI,yCAAA;AAER;AAAI;EACI,UAAA;EACA,kBAAA;EACA,2BAAA;AAER;AADQ;EACI,YAAA;AAGZ;AADQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAGZ;;AAEA;EACI;IACI,0BAAA;IACA,mCAAA;IACA,qCAAA;EACN;EAAM;IACI,YAAA;EAEV;AACF","sourcesContent":[".modal-dialog {\n    max-width: 80%;\n    width: fit-content;\n    &> .modal-content {\n        background-color: var(--modal) !important;\n    }\n    &:has(.archivo-modal) {\n        width: 90%;\n        max-width: initial;\n        height: calc(100% - 3.5rem);\n        & .modal-content, .modal-body {\n            height: 100%;\n        }\n        & .archivo-modal:has(img) {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            overflow: auto\n        }\n    }\n}\n\n@media (max-width: 575.98px) {\n    .modal-dialog {\n        max-width: 100% !important;\n        width: calc(100% - 1rem) !important;\n        height: calc(100vh - 1rem) !important;\n        & .modal-content {\n            height: 100%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
